export class WholesalerSimulationGlobalInformation {
  id!: number;
  pharmacyRefId!: number;
  wholesalerId!: number;
  wholesalerName?: string;
  month?: number;
  year?: number;
  calculationName?: string;
  calculationResult?: string;

  static fromBackend(data: any): WholesalerSimulationGlobalInformation {
    return {
      id: data.id,
      pharmacyRefId: data.idOfficineRef,
      wholesalerId: data.idGrossiste,
      wholesalerName: data.nomGrossiste,
      month: data.mois,
      year: data.annee,
      calculationName: data.nomCalcul,
      calculationResult: data.valeurCalcul,
    } as WholesalerSimulationGlobalInformation;
  }

  static fromBackendList(data: any[]): WholesalerSimulationGlobalInformation[] {
    return data.map(item => WholesalerSimulationGlobalInformation.fromBackend(item));
  }
}
